
import {defineComponent, onMounted} from "vue";
import Quill from "quill/dist/quill.js";
import Dropdown2 from "@/components/dropdown/Dropdown2.vue";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import {useToast} from "vue-toastification";

export default defineComponent({
    name: "payments-methods",
    props: {
        widgetClasses: String,
        currentUser: {},
    },
    components: {
        // Dropdown2,
    },
    setup() {
        const toast = useToast();

        const onCopy = (e) => {
            toast.success("Платіжний код скопійовано в буфер обміну!");
        };

        const onCopyError = (e) => {
            toast.error("Помилка при копіюванні платіжного коду в буфер обміну!");
        };

        onMounted(() => {
            const editorId = "kt_forms_widget_1_editor";

            // init editor
            const options = {
                modules: {
                    toolbar: {
                        container: "#kt_forms_widget_1_editor_toolbar",
                    },
                },
                theme: "snow",
            };

            // Init editor
            //new Quill("#" + editorId, options);
        });

        return {
            onCopy,
            onCopyError,
        };
    },
});
